const ULTIMO_EMAIL_KEY = "ultimoEmail";
const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshtoken";
const VALIDADE_TOKEN_KEY = "validadetoken";
const CODIGO_LOGIN_KEY = "codigoLogin";

class AuthHelper {
  setUltimoEmail(value) {
    localStorage.setItem(ULTIMO_EMAIL_KEY, value);
  }

  getUltimoEmail() {
    return localStorage.getItem(ULTIMO_EMAIL_KEY);
  }

  setToken(value) {
    return localStorage.setItem(TOKEN_KEY, value);
  }

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  }

  setRefreshToken(value) {
    localStorage.setItem(REFRESH_TOKEN_KEY, value);
  }

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setValidadeToken(value) {
    localStorage.setItem(VALIDADE_TOKEN_KEY, value);
  }

  getValidadeToken() {
    return localStorage.getItem(VALIDADE_TOKEN_KEY);
  }

  setCodigoLogin(value) {
    localStorage.setItem(CODIGO_LOGIN_KEY, value);
  }

  getCodigoLogin() {
    return localStorage.getItem(CODIGO_LOGIN_KEY);
  }

  limparDadosAutenticacao() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(VALIDADE_TOKEN_KEY);
    localStorage.removeItem(CODIGO_LOGIN_KEY);
  }

  isTokenValido() {
    const tokenAuth = this.getToken();

    if (!tokenAuth) return false;

    const validadeToken = this.getValidadeToken();

    if (typeof validadeToken === "string") {
      const validadeTipoDate = new Date(validadeToken);

      validadeTipoDate.setMinutes(validadeTipoDate.getMinutes() - 5);

      return validadeTipoDate > new Date();
    }

    return false;
  }
}

export default new AuthHelper();
